import { ContentSectionContainer } from "pages/[tenant]/console/components/molecules/ContentSection/molecules/atoms/Container";
import { ContentSectionRow } from "pages/[tenant]/console/components/molecules/ContentSection/molecules/atoms/Row";

export const ContentSection = {
  Container: ContentSectionContainer,
  Row: ContentSectionRow,
};
